import { api } from './api';
import { NotificationRequest, FieldFlag } from '../types';

export const sendNotification = async (notification: NotificationRequest): Promise<any> => {
  try {
    const response = await api.post('/notifications/send', notification);
    return response.data;
  } catch (error) {
    console.error('Failed to send notification:', error);
    throw error;
  }
};

export const sendReworkRequest = async (
  employeeId: string,
  candidateEmail: string,
  candidateName: string,
  reason: string,
  fieldFlags: FieldFlag[]
): Promise<any> => {
  try {
    const notification: NotificationRequest = {
      to: candidateEmail,
      subject: 'Application Update Required',
      template: 'rework_required',
      data: {
        candidateName,
        candidateEmail,
        referenceNumber: employeeId,
        issues: reason,
      },
      fieldFlags
    };

    return await sendNotification(notification);
  } catch (error) {
    console.error('Failed to send rework request:', error);
    throw error;
  }
};

export const sendWelcomeEmail = async (
  employee: any,
  temporaryPassword: string
): Promise<any> => {
  try {
    if (!employee.email) {
      throw new Error('Cannot send welcome email: employee has no email address');
    }

    const notification: NotificationRequest = {
      to: employee.email,
      subject: 'Welcome to the Team!',
      template: 'welcome',
      data: {
        firstName: employee.fullNames,
        email: employee.email,
        employeeNumber: employee.employeeNumber || 'TBD',
        department: employee.department || 'TBD',
        position: employee.positionAppliedFor,
        startDate: new Date().toLocaleDateString(),
        temporaryPassword,
      }
    };

    return await sendNotification(notification);
  } catch (error) {
    console.error('Failed to send welcome email:', error);
    throw error;
  }
};

export const sendDraftLinkEmail = async (
  email: string,
  draftLink: string,
  referenceNumber: string,
  candidateName?: string
): Promise<any> => {
  const notification: NotificationRequest = {
    to: email,
    subject: 'Your draft application link',
    template: 'draft_link',
    data: {
      draftLink,
      referenceNumber,
      candidateName,
    },
  };

  return await sendNotification(notification);
};

